import { validator } from "@/utils/validator";
import { MAX_CHARACTER_INPUT_VALIDATION, MAX_INTEGER, MAX_TEXT_INPUT_VALIDATION } from "@/constants/common";
import { EIndustryExamType } from "@/types/enum";
import { PATTERN } from "@/constants/pattern";

// 受験要件: each requirement box (項目名 + 要件の説明文), all optional
const examRequirementSchema = validator.object().shape({
  name: validator.string().trim().emptyToNull().max(MAX_CHARACTER_INPUT_VALIDATION).label("項目名").notRequired(),
  description: validator.string().trim().emptyToNull().max(MAX_TEXT_INPUT_VALIDATION).label("要件の説明文").notRequired(),
});

export const industrySchema = validator.object().shape({
  name: validator.string().trim().emptyToNull().max(255).label("分野名").required(),
  isActive: validator.boolean().label("有効フラグ").notRequired().default(false),
  activationDate: validator.mixed().isSelection().isDayjs().label("有効化日").notRequired(),
  internalMemo: validator.string().trim().emptyToNull().max(MAX_TEXT_INPUT_VALIDATION).label("社内メモ").notRequired(),
  examType: validator
    .string()
    .trim()
    .emptyToNull()
    .oneOf([EIndustryExamType.PAPER_TEST, EIndustryExamType.CBT], "試験種別を選択してください")
    .label("試験種別")
    .notRequired()
    .default(EIndustryExamType.CBT),
  examOrganization: validator.string().trim().emptyToNull().max(MAX_CHARACTER_INPUT_VALIDATION).label("試験実施機関").required(),
  examInfoReleaseEstimate: validator.string().trim().emptyToNull().max(MAX_CHARACTER_INPUT_VALIDATION).label("試験情報の公開目安").notRequired(),
  examInfoUrl: validator
    .string()
    .trim()
    .emptyToNull()
    .max(MAX_TEXT_INPUT_VALIDATION)
    .matches(PATTERN.CUSTOM_URL, "正しいURL形式で入力してください。")
    .label("試験情報URL")
    .notRequired(),
  nextExamDate: validator.mixed().isSelection().isDayjs().label("次の試験日").notRequired(),
  displayOrder: validator.number().integer().autoTransformToHalfWidth().min(0).max(MAX_INTEGER).label("表示順序").notRequired().default(0),
  examRequirements: validator.array().of(examRequirementSchema).notRequired(),
});
